import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projHerbalens from "../assets/img/project-herbalens.png";
import projPrinting from "../assets/img/project-printing.png";
import projJudolSlayer from "../assets/img/project-judol-slayer.png";
import projKrealogi from "../assets/img/project-krealogi.png";
import projGoLearn from "../assets/img/project-go-learn.png";
import projHealhGearShare from "../assets/img/project-health-gear-share.png";
import projInfPinjamAja from "../assets/img/project-inf-pinjam-aja.png";
import projectMailGeneratorForJob from "../assets/img/project-mail-generator-for-job.png";
import projectPortfolio from "../assets/img/project-portfolio.png";
import colorSharp2 from "../assets/img/color-sharp.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const webProjects = [
    {
      title: "Judol Slayer - Slay judol youtube comments",
      techStack: ["nextjs2", "materialui", "nodejs", "typescript", "js", "css3"],
      imgUrl: projJudolSlayer,
      source: "https://judol-slayer.frisrsyd.tech",
    },
    {
      title: "Digital Printing Business Management System",
      techStack: ["laravel", "mysql", "php", "bootstrap5",],
      imgUrl: projPrinting,
      source: "https://github.com/AfkarSiddiq/KKP-Percetakan",
    },
    {
      title: "HealtGearShare",
      techStack: ["nodejs", "edge", "mysql", "bootstrap5", "js", "css3"],
      imgUrl: projHealhGearShare,
      source: "https://github.com/frisrsyd/HealthGearShare",
    },
    {
      title: "InfPinjamAja",
      techStack: ["nodejs", "edge", "mysql", "bootstrap5", "js", "css3"],
      imgUrl: projInfPinjamAja,
      source: "https://github.com/frisrsyd/Inf-PinjamAJa",
    },
    {
      title: "Mail Genearator for Job",
      techStack: ["reactjs", "nodejs", "bootstrap5", "js", "css3"],
      imgUrl: projectMailGeneratorForJob,
      source: "https://mail-for-job-generator.vercel.app",
    },
    {
      title: "Portofolio",
      techStack: ["reactjs", "nodejs", "bootstrap5", "js", "css3"],
      imgUrl: projectPortfolio,
      source: "#home",
    }
  ];

  const uiProjects = [
    {
      title: "Mendesain Fitur Integrasi Marketplace dan Logistik Krealolgi — UX Case Study",
      techStack: ["figma"],
      imgUrl: projKrealogi,
      source: "https://medium.com/@frisrsyd/mendesain-fitur-integrasi-marketplace-dan-logistik-krealolgi-ux-case-study-e955f4353e83",
    },
    {
      title: "Go Learn — UX Case Study",
      techStack: ["figma"],
      imgUrl: projGoLearn,
      source: "https://medium.com/@frisrsyd/go-learn-ux-case-study-364d3c48d451"
    },
  ];

  const androidProjects = [
    {
      title: "Herbalens",
      techStack: ["kotlin", "android", "vscode", "figma", "materialui", "git", "github"],
      imgUrl: projHerbalens,
      source: "https://github.com/orgs/c23-ps131-herbalens/",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Check out some of my projects, meticulously crafted with love and dedication, each one reflecting the passion and soul I poured into every detail.</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Web Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">UI/UX Project</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Android Project</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          webProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Row>
                        {
                          uiProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <Row>
                        {
                          androidProjects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-left" src={colorSharp2} alt=""></img>
    </section>
  )
}
